<template>
	<div
		class="ks-videoeditor-track ks-videoeditor-track-audio"
		:data-id="track.id"
		data-kind="audio"
		:style="track_style"
		@mousedown.prevent="$emit('scrub-down', $event)"
		@click="$emit('background-click')">
		<div
			v-for="item in track.items"
			:key="item.audio.id"
			class="ks-videoeditor-clip ks-videoeditor-audio has-wave"
			:class="{selected: item.audio.id == selected_id}"
			:style="block_style(item.audio.start, item.audio.duration, item.lane, 'audio', item.audio.id)"
			@mousedown.stop.prevent="$emit('item-down', item.audio, 'move', $event)"
			@click.stop>
			<div class="ks-videoeditor-handle left" @mousedown.stop.prevent="$emit('item-down', item.audio, 'start', $event)"></div>
			<div class="ks-videoeditor-clip-text inline">
				<div class="ks-videoeditor-clip-title">{{ item.audio.title }}</div>
				<div class="ks-videoeditor-clip-time">{{ fmt(item.audio.duration) }} &middot; {{ item.audio.volume }}%</div>
			</div>
			<wave-form
				:url="item.audio.url"
				:from="item.audio.in"
				:len="item.audio.duration"
				:gain="item.audio.volume / 100"
				:muted="!!track.muted"
				:zoom="zoom"></wave-form>
			<div class="ks-videoeditor-handle right" @mousedown.stop.prevent="$emit('item-down', item.audio, 'end', $event)"></div>
		</div>
	</div>
</template>

<script>
import track_mixin from './track_mixin.js'
import WaveForm from './WaveForm.vue'
import {fmt} from './utils.js'

// Track of audio items
export default {
	mixins: [track_mixin],
	components: {WaveForm},
	props: {
		selected_id: Number
	},
	methods: {
		fmt
	}
}
</script>
